import { useAtomValue } from "jotai/index";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account";

import { appAtom } from "scmp-app/lib/app/atoms";
import { useDetectAdBlock } from "scmp-app/lib/hooks";
import { rosettaAtom } from "scmp-app/lib/rosetta";

import { sendGA4UserPropertiesTracking } from "./apis";

export const useSetGA4UserProperties = () => {
  const asyncAdBlockState = useDetectAdBlock();
  const { isLoggedIn, loginType } = useAtomValue(accountAtom);
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { navigatorInfo } = useAtomValue(appAtom);

  useEffect(() => {
    if (!navigatorInfo) return;

    sendGA4UserPropertiesTracking({
      botCategory: navigatorInfo?.botCategory,
      botScore: navigatorInfo?.botScore ?? 0,
      isBot: navigatorInfo?.isBot ?? false,
    });
  }, [navigatorInfo]);

  useEffect(() => {
    if (!loginType) return;

    sendGA4UserPropertiesTracking({ loginType });
  }, [loginType]);

  useEffect(() => {
    if (!asyncRosettaState?.result) return;

    const userRole =
      asyncRosettaState?.result?.tracking?.userRole ??
      (isLoggedIn ? "authenticated user" : "anonymous user");

    sendGA4UserPropertiesTracking({ ga4UserRole: userRole });
  }, [asyncRosettaState?.result, isLoggedIn]);

  useEffect(() => {
    if (!asyncAdBlockState.result) return;

    sendGA4UserPropertiesTracking({ abBlocker: asyncAdBlockState.result ? "yes" : "no" });
  }, [asyncAdBlockState]);
};
